/**
 * @export
 */
export const AiChatMessageRoleEnum = {
    system: 'system',
    user: 'user',
    assistant: 'assistant',
    tool: 'tool'
};
/**
 * @export
 */
export const AviationLayerKindEnum = {
    AviationLayerDescription: 'AviationLayerDescription'
};
/**
 * @export
 */
export const AviationLayerCreateKindEnum = {
    AviationLayerDescription: 'AviationLayerDescription'
};
/**
 * @export
 */
export const AviationLayerUpdateKindEnum = {
    AviationLayerDescription: 'AviationLayerDescription'
};
/**
 * @export
 */
export const BackgroundMapLayerKindEnum = {
    BackgroundMapDescription: 'BackgroundMapDescription'
};
/**
 * @export
 */
export const BackgroundMapLayerCreateKindEnum = {
    BackgroundMapDescription: 'BackgroundMapDescription'
};
/**
 * @export
 */
export const BackgroundMapLayerUpdateKindEnum = {
    BackgroundMapDescription: 'BackgroundMapDescription'
};
/**
 * @export
 */
export const BarbsLayerKindEnum = {
    BarbsLayerDescription: 'BarbsLayerDescription'
};
/**
 * @export
 */
export const BarbsLayerCreateKindEnum = {
    BarbsLayerDescription: 'BarbsLayerDescription'
};
/**
 * @export
 */
export const BarbsLayerCustomOptionsIconTypeEnum = {
    barbs: 'barbs',
    arrows: 'arrows'
};
/**
 * @export
 */
export const BarbsLayerCustomOptionsUpdateIconTypeEnum = {
    barbs: 'barbs',
    arrows: 'arrows'
};
/**
 * @export
 */
export const BarbsLayerUpdateKindEnum = {
    BarbsLayerDescription: 'BarbsLayerDescription'
};
/**
 * @export
 */
export const CustomGeoJSONLayerCreateKindEnum = {
    CustomGeoJSONLayerDescription: 'CustomGeoJSONLayerDescription'
};
/**
 * @export
 */
export const CustomGeoJSONLayerInputKindEnum = {
    CustomGeoJSONLayerDescription: 'CustomGeoJSONLayerDescription'
};
/**
 * @export
 */
export const CustomGeoJSONLayerOutputKindEnum = {
    CustomGeoJSONLayerDescription: 'CustomGeoJSONLayerDescription'
};
/**
 * @export
 */
export const CustomGeoJSONLayerUpdateKindEnum = {
    CustomGeoJSONLayerDescription: 'CustomGeoJSONLayerDescription'
};
/**
 * @export
 */
export const DrawingLayerKindEnum = {
    DrawingLayerDescription: 'DrawingLayerDescription'
};
/**
 * @export
 */
export const DrawingLayerUpdateKindEnum = {
    DrawingLayerDescription: 'DrawingLayerDescription'
};
/**
 * @export
 */
export const EarthquakeLayerKindEnum = {
    EarthquakeLayerDescription: 'EarthquakeLayerDescription'
};
/**
 * @export
 */
export const EarthquakeLayerCreateKindEnum = {
    EarthquakeLayerDescription: 'EarthquakeLayerDescription'
};
/**
 * @export
 */
export const EarthquakeLayerUpdateKindEnum = {
    EarthquakeLayerDescription: 'EarthquakeLayerDescription'
};
/**
 * @export
 */
export const GenericPoiLayerKindEnum = {
    GenericPoiLayerDescription: 'GenericPoiLayerDescription'
};
/**
 * @export
 */
export const GenericPoiLayerCreateKindEnum = {
    GenericPoiLayerDescription: 'GenericPoiLayerDescription'
};
/**
 * @export
 */
export const GenericPoiLayerUpdateKindEnum = {
    GenericPoiLayerDescription: 'GenericPoiLayerDescription'
};
/**
 * @export
 */
export const GridLayerKindEnum = {
    GridLayerDescription: 'GridLayerDescription'
};
/**
 * @export
 */
export const GridLayerCreateKindEnum = {
    GridLayerDescription: 'GridLayerDescription'
};
/**
 * @export
 */
export const GridLayerUpdateKindEnum = {
    GridLayerDescription: 'GridLayerDescription'
};
/**
 *
 * @export
 */
export const GuiTimeZone = {
    utc: 'utc',
    local: 'local'
};
/**
 * @export
 */
export const HodographUnitWindSpeedEnum = {
    m_s: 'm/s',
    knot: 'knot'
};
/**
 * @export
 */
export const HodographUnitWindDirectionEnum = {
    deg: 'deg'
};
/**
 * @export
 */
export const HodographUnitAltitudeEnum = {
    m: 'm',
    ft: 'ft',
    hPa: 'hPa'
};
/**
 * @export
 */
export const IsoBandsLayerKindEnum = {
    IsoBandsLayerDescription: 'IsoBandsLayerDescription'
};
/**
 * @export
 */
export const IsoBandsLayerCreateKindEnum = {
    IsoBandsLayerDescription: 'IsoBandsLayerDescription'
};
/**
 * @export
 */
export const IsoBandsLayerUpdateKindEnum = {
    IsoBandsLayerDescription: 'IsoBandsLayerDescription'
};
/**
 * @export
 */
export const IsoLinesLayerKindEnum = {
    IsoLinesLayerDescription: 'IsoLinesLayerDescription'
};
/**
 * @export
 */
export const IsoLinesLayerCreateKindEnum = {
    IsoLinesLayerDescription: 'IsoLinesLayerDescription'
};
/**
 * @export
 */
export const IsoLinesLayerUpdateKindEnum = {
    IsoLinesLayerDescription: 'IsoLinesLayerDescription'
};
/**
 * @export
 */
export const JetStreamsLayerKindEnum = {
    JetStreamsLayerDescription: 'JetStreamsLayerDescription'
};
/**
 * @export
 */
export const JetStreamsLayerCreateKindEnum = {
    JetStreamsLayerDescription: 'JetStreamsLayerDescription'
};
/**
 * @export
 */
export const JetStreamsLayerUpdateKindEnum = {
    JetStreamsLayerDescription: 'JetStreamsLayerDescription'
};
/**
 *
 * @export
 */
export const LayoutType = {
    Map: 'Map',
    Plot: 'Plot',
    WeatherTable: 'WeatherTable',
    LocationTable: 'LocationTable',
    EnergyPlot: 'EnergyPlot',
    Tephigram: 'Tephigram',
    CountryPlot: 'CountryPlot',
    Notes: 'Notes',
    Undefined: 'Undefined'
};
/**
 * @export
 */
export const LightningLayerKindEnum = {
    LightningLayerDescription: 'LightningLayerDescription'
};
/**
 * @export
 */
export const LightningLayerCreateKindEnum = {
    LightningLayerDescription: 'LightningLayerDescription'
};
/**
 * @export
 */
export const LightningLayerUpdateKindEnum = {
    LightningLayerDescription: 'LightningLayerDescription'
};
/**
 *
 * @export
 */
export const MarketplaceTier = {
    Core: 'Core',
    Pro: 'Pro',
    Premium: 'Premium'
};
/**
 * @export
 */
export const NwaLayerKindEnum = {
    NwaLayerDescription: 'NwaLayerDescription'
};
/**
 * @export
 */
export const NwaLayerCreateKindEnum = {
    NwaLayerDescription: 'NwaLayerDescription'
};
/**
 * @export
 */
export const NwaLayerUpdateKindEnum = {
    NwaLayerDescription: 'NwaLayerDescription'
};
/**
 * @export
 */
export const PressureSystemLayerKindEnum = {
    PressureSystemLayerDescription: 'PressureSystemLayerDescription'
};
/**
 * @export
 */
export const PressureSystemLayerCreateKindEnum = {
    PressureSystemLayerDescription: 'PressureSystemLayerDescription'
};
/**
 * @export
 */
export const PressureSystemLayerUpdateKindEnum = {
    PressureSystemLayerDescription: 'PressureSystemLayerDescription'
};
/**
 *
 * @export
 */
export const ProjectionNameEnum = {
    mercator: 'mercator',
    albers: 'albers',
    equalEarth: 'equalEarth',
    equirectangular: 'equirectangular',
    lambertConformalConic: 'lambertConformalConic',
    naturalEarth: 'naturalEarth',
    winkelTripel: 'winkelTripel',
    globe: 'globe'
};
/**
 *
 * @export
 */
export const RelativeDateTimePosition = {
    now_with_5min_precision: 'now_with_5min_precision',
    now_with_10min_precision: 'now_with_10min_precision',
    now_with_15min_precision: 'now_with_15min_precision',
    now_with_30min_precision: 'now_with_30min_precision',
    now_with_1h_precision: 'now_with_1h_precision',
    now_with_6h_precision: 'now_with_6h_precision',
    now_with_12h_precision: 'now_with_12h_precision',
    day: 'day'
};
/**
 *
 * @export
 */
export const RelativeDateTimeRoundingDirection = {
    forward: 'forward',
    backward: 'backward'
};
/**
 *
 * @export
 */
export const SoundingParamType = {
    MU: 'MU',
    ML: 'ML',
    SB: 'SB'
};
/**
 * @export
 */
export const StationLayerKindEnum = {
    StationLayerDescription: 'StationLayerDescription'
};
/**
 * @export
 */
export const StationLayerCreateKindEnum = {
    StationLayerDescription: 'StationLayerDescription'
};
/**
 * @export
 */
export const StationLayerUpdateKindEnum = {
    StationLayerDescription: 'StationLayerDescription'
};
/**
 * @export
 */
export const SymbolLayerKindEnum = {
    SymbolLayerDescription: 'SymbolLayerDescription'
};
/**
 * @export
 */
export const SymbolLayerCreateKindEnum = {
    SymbolLayerDescription: 'SymbolLayerDescription'
};
/**
 *
 * @export
 */
export const SymbolLayerType = {
    WeatherSymbol: 'WeatherSymbol',
    WeatherCode: 'WeatherCode'
};
/**
 * @export
 */
export const SymbolLayerUpdateKindEnum = {
    SymbolLayerDescription: 'SymbolLayerDescription'
};
/**
 *
 * @export
 */
export const TelemetrySignal = {
    traces: 'traces',
    metrics: 'metrics',
    logs: 'logs'
};
/**
 * @export
 */
export const ThunderstormLayerKindEnum = {
    ThunderstormTrackingLayerDescription: 'ThunderstormTrackingLayerDescription'
};
/**
 * @export
 */
export const ThunderstormLayerCreateKindEnum = {
    ThunderstormTrackingLayerDescription: 'ThunderstormTrackingLayerDescription'
};
/**
 * @export
 */
export const ThunderstormLayerUpdateKindEnum = {
    ThunderstormTrackingLayerDescription: 'ThunderstormTrackingLayerDescription'
};
/**
 * @export
 */
export const TropicalCycloneLayerKindEnum = {
    TropicalCycloneLayerDescription: 'TropicalCycloneLayerDescription'
};
/**
 * @export
 */
export const TropicalCycloneLayerCreateKindEnum = {
    TropicalCycloneLayerDescription: 'TropicalCycloneLayerDescription'
};
/**
 * @export
 */
export const TropicalCycloneLayerUpdateKindEnum = {
    TropicalCycloneLayerDescription: 'TropicalCycloneLayerDescription'
};
/**
 *
 * @export
 */
export const Units = {
    kilometers: 'kilometers',
    miles: 'miles',
    radians: 'radians',
    degrees: 'degrees'
};
/**
 *
 * @export
 */
export const UserFeature = {
    export_table: 'export_table'
};
/**
 *
 * @export
 */
export const UserGroupEnum = {
    admin: 'admin',
    internal: 'internal',
    sales: 'sales',
    viewer: 'viewer',
    viewer_plus: 'viewer_plus',
    customer: 'customer'
};
/**
 *
 * @export
 */
export const VerticalInterpolationType = {
    none: 'none',
    downscale: 'downscale'
};
/**
 *
 * @export
 */
export const ViewportKind = {
    ViewportFull: 'ViewportFull',
    ViewportCenterPoint: 'ViewportCenterPoint',
    ViewportContainBounds: 'ViewportContainBounds'
};
/**
 * @export
 */
export const WeatherFrontsLayerKindEnum = {
    WeatherFrontsLayerDescription: 'WeatherFrontsLayerDescription'
};
/**
 * @export
 */
export const WeatherFrontsLayerCreateKindEnum = {
    WeatherFrontsLayerDescription: 'WeatherFrontsLayerDescription'
};
/**
 * @export
 */
export const WeatherFrontsLayerUpdateKindEnum = {
    WeatherFrontsLayerDescription: 'WeatherFrontsLayerDescription'
};
/**
 * @export
 */
export const WindAnimationLayerKindEnum = {
    WindAnimationLayerDescription: 'WindAnimationLayerDescription'
};
/**
 * @export
 */
export const WindAnimationLayerCreateKindEnum = {
    WindAnimationLayerDescription: 'WindAnimationLayerDescription'
};
/**
 * @export
 */
export const WindAnimationLayerUpdateKindEnum = {
    WindAnimationLayerDescription: 'WindAnimationLayerDescription'
};
/**
 * @export
 */
export const WmsLayerKindEnum = {
    WmsLayerDescription: 'WmsLayerDescription'
};
/**
 * @export
 */
export const WmsLayerCreateKindEnum = {
    WmsLayerDescription: 'WmsLayerDescription'
};
/**
 * @export
 */
export const WmsLayerUpdateKindEnum = {
    WmsLayerDescription: 'WmsLayerDescription'
};
